<span [innerHTML]="eventItem && eventItem.start ? (eventItem!.start | date:'d') : ''"></span>
@if (haveDifferentMonths(eventItem)) {
  <span>&nbsp;</span>
  <span [innerHTML]="eventItem && eventItem.start ? formatDate(eventItem!.start!) + ' ' : ''"></span>
}
@if (haveDifferentYears(eventItem)) {
  <span [innerHTML]="eventItem && eventItem.start ? (eventItem!.start | date:'yyyy') : ''"></span>
}
@if (checkSameDate(eventItem)) {
  <span>
    ➜
    <span [innerHTML]="eventItem && eventItem.end ? (eventItem!.end | date:'d') : ''"></span>
  </span>
}
<span>&nbsp;</span>
@if (haveDifferentMonths(eventItem)) {
  <span [innerHTML]="eventItem && eventItem.end ? formatDate(eventItem!.end!) + ' ' : ''"></span>
} @else {
  <span [innerHTML]="eventItem && eventItem.start ? formatDate(eventItem!.start!) + ' ' : ''"></span>
}
@if (haveDifferentYears(eventItem)) {
  <span [innerHTML]="eventItem && eventItem.end ? (eventItem!.end | date:'yyyy') : ''"></span>
} @else {
  <span [innerHTML]="eventItem && eventItem.start ? (eventItem!.start | date:'yyyy') : ''"></span>
}
